<script lang="ts">
export default {
  name: "StartpageMiniToolItem",
};
</script>
<script setup lang="ts">
import BaseMediaItem from "@/components/Base/MediaItem.vue";
import { type MediaItem } from "@/components/Base/MediaItem.vue";
import LazyImage from "@/components/LazyImage.vue";
import { AiMiniTool } from "@/services/fobizzToolsApi";

type Props = {
  miniTool: AiMiniTool;
  hideBadge?: boolean;
};

const props = withDefaults(defineProps<Props>(), {
  hideBadge: false,
});

const item = computed(() => {
  const item: MediaItem = {
    id: props.miniTool.id,
    title: props.miniTool.name,
    description: props.miniTool.description || "",
    path: `/ai/mini_tools/${props.miniTool.id}`,
    dataTestId: `link-${props.miniTool.id}`,
    experimental: false,
    new: props.miniTool.featured,
  };
  return item;
});
</script>

<template>
  <BaseMediaItem :item="item" :hide-badge="props.hideBadge">
    <template #media>
      <div class="avatar">
        <LazyImage
          v-if="miniTool.avatar && miniTool.avatar.previewUrl"
          :src="miniTool.avatar.previewUrl"
          alt="Avatar"
        />
        <div v-else class="avatar_placeholder"></div>
      </div>
    </template>
  </BaseMediaItem>
</template>

<style lang="scss" scoped>
.avatar {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: $gray-100;
  overflow: hidden;

  img {
    max-width: 100%;
    height: auto;
  }

  @include media-breakpoint-down(md) {
    width: 30px;
    height: 30px;
  }
}

.avatar_placeholder {
  color: $gray-400;
}
</style>
